<ion-datetime-button
    [id]="name + '_datepicker-btn'"
    class="datepicker-btn"
    [datetime]="name + '_datetime'"
>
    <ion-item [button]="true" slot="date-target" lines="full" [detail]="false">
        <ion-label [class]="!removeStyling ? 'ion-text-wrap date-label' : ''">
            <ion-icon *ngIf="!removeStyling" name="calendar"></ion-icon>
            {{ label }}
        </ion-label>
        <ion-note [class]="!removeStyling ? 'date-note' : ''" slot="end">{{ value }}</ion-note>
    </ion-item>
</ion-datetime-button>

<ion-modal [id]="name + '_datepicker'" class="datepicker" #datepicker [keepContentsMounted]="true">
    <ng-template>
        <ion-datetime
            [id]="name + '_datetime'"
            value="{{ rawValue }}"
            [attr.min]="minDate ? minDate : null"
            [attr.max]="maxDate ? maxDate : null"
            presentation="date"
            [firstDayOfWeek]="1"
            mode="md"
            (ionChange)="setValue($event)"
        >
        </ion-datetime>
    </ng-template>
</ion-modal>
